module.exports = __webpack_public_path__ + "static/img/01.e910843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/01.png
// module id = uIiD
// module chunks = 1